import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Work from "./views/Work.vue";
import WorkExplore from "./views/WorkExplore.vue";
import WorkTemplate from "./views/WorkTemplate.vue";
import Culture from "./views/Culture.vue";
import CultureExplore from "./views/CultureExplore.vue";
import Expertise from "./views/Expertise.vue";
import ExpertiseExplore from "./views/ExpertiseExplore.vue";
import News from "./views/News.vue";
import NewsExplore from "./views/NewsExplore.vue";
import NewsTemplate from "./views/NewsTemplate.vue";
import Contact from "./views/Contact.vue";
import ContactExplore from "./views/ContactExplore.vue";
import PrivacyPolicy from "./views/PrivacyPolicy.vue";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
    {
        path: "/",
        alias: "/home",
        name: "home",
        component: Home
    },
    {
        path: "/work",
        name: "work",
        component: Work
    },
    {
        path: "/work/case-studies",
        name: "work-explore",
        component: WorkExplore
    },
    {
        path: "/work/case-studies/:id",
        name: "work-tempalte",
        component: WorkTemplate
    },
    {
        path: "/culture",
        name: "culture",
        component: Culture
    },
    {
        path: "/culture/:anchor",
        name: "explore",
        component: CultureExplore
    },
    {
        path: "/expertise",
        name: "expertise",
        component: Expertise
    },
    {
        path: "/expertise/:id",
        name: "expertise-explore",
        component: ExpertiseExplore
    },
    {
        path: "/expertise/:id/:child",
        name: "expertise-explore-anchor",
        component: ExpertiseExplore
    },
    {
        path: "/news",
        name: "news",
        component: News
    },
    {
        path: "/news/newswire",
        name: "news-explore",
        component: NewsExplore
    },
    {
        path: "/news/newswire/:id",
        name: "news-template",
        component: NewsTemplate
    },
    {
        path: "/contact",
        name: "contact",
        component: Contact
    },
    {
        path: "/contact/be-a-hunter",
        name: "contact-explore",
        component: ContactExplore
    },
    {
        path: "/contact/be-a-hunter/:anchor",
        name: "contact-explore-anchor",
        component: ContactExplore
    },
    {
        path: "/privacypolicy",
        name: "privacypolicy",
        component: PrivacyPolicy
    }
    ],
    scrollBehavior (to, from, savedPosition) {
        //console.log(to);
        //console.log(from);
        //return { x: 0, y: 0 }
    }
});
